/**
 * Stub for @react-native-firebase/auth/lib/modular - web build only.
 */
const noop = () => {};
const noopAsync = () => Promise.resolve();

module.exports = {
    getAuth: noop,
    onAuthStateChanged: noop,
    signInAnonymously: noopAsync,
    signOut: noopAsync,
    signInWithPhoneNumber: noopAsync,
    signInWithCredential: noopAsync,
    signInWithCustomToken: noopAsync,
};
